export const companyName = "Cenaudze, SIA";
export const companyBankInfo = "Swedbank A/S HABALV22";
export const companyBankAccount = "LV20HABA0551061606879";
export const companyRegistrationNumber = "40203656752";
export const companyPhone = "+371 29 854 727";
export const companyEmail = "info@cenaudze.lv";
export const companyLegalAddress = 'Saldus nov., Zirņu pag., "Jaunsērži"';

export const technicalSupportPhone = "+371 28 325 837";
export const technicalSupportEmail = "info@cenaudze.lv";

export const gdprEmail = "info@cenaudze.lv";
